import floripa from "./tourism-images/floripa.jpg";
import balneario from "./tourism-images/balneario.jpg";
import beto from "./tourism-images/beto-carrero.jpg";
import praia from "./tourism-images/bruno-soares-9Oxo5TLb9nw-unsplash.jpg";
import berries from "./tourism-images/photo_2024-01-22_10-16-47.jpg";

const tourismData = [
    {
      id: 1,
      title: "Интересные места во Флорипе",
      picture: floripa, 
      date: "16 апреля 2025",
      excerpt: "Путеводитель по острову",
      link: "/tourism/floripa-guide",
    },
    {
      id: 2,
      title: "Бразильский Дубай",
      picture: balneario, 
      date: "23 апреля 2025",
      excerpt: "Что посмотреть в Бальнеариу Камбориу?",
      link: "/tourism/balneario-camborio",
    },
    {
      id: 3,
      title: "Парк аттракционов Beto Carrero",
      picture: beto, 
      date: "23 апреля 2025",
      excerpt: "Самый большой парк аттракционов в ЛА",
      link: "/tourism/beto-carrero",
    },
    {
      id: 4,
      title: "ТОП-30 мест во Флорипе",
      picture: praia, 
      date: "12 мая 2025",
      excerpt: "Must visit во Флорипе",
      link: "/tourism/floripa-locations",
    },
    {
      id: 5,
      title: "Клубничная ферма",
      picture: berries, 
      date: "13 мая 2025",
      excerpt: "Где собрать клубнику и что посмотреть?",
      link: "/tourism/sitio-do-morango",
    },
  ];
  
  export default tourismData;